module.exports = __webpack_public_path__ + "static/media/avatar.d24800ab.svg";